import { Transition, Dialog } from "@headlessui/react";
import { Fragment } from "react";

export default function GoldBenefits({
  isOpen,
  onClose,
}: {
  isOpen: any;
  onClose: () => void;
}) {
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative w-full z-10" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed w-full inset-0 bg-black bg-opacity-50" />
        </Transition.Child>

        <div className="fixed w-[100%] inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center md:px-[15%] text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-[100%] mt-1/4 transform overflow-hidden rounded-2xl md:border-[2px] md:border-[#9A7026] bg-white p-6 text-left align-middle shadow-xl transition-all">
                <Dialog.Title
                  as="h3"
                  className="text-2xl font-semibold mb-3  leading-6 text-gray-900"
                ></Dialog.Title>
                <div className=" bg-white flex flex-col gap-[37px] p-8 pr-0 item-start justify-center py-[32px] pl-[32px]  lg:grid lg:grid-cols-2 lg:grid-rows-2 lg:gap-[42px] lg:px-[63px] lg:py-8 rounded-xl ">
                  <div className="flex flex-row items-center justify-center gap-[22px]">
                    <img src="/astro-gold/phone-talking.png" alt="" />
                    <div className="flex flex-col items-start justify-center">
                      <p className="text-[15.9px] max-md:text-[15.98px] font-[700] text-[#1A1A1A]">
                        Free Consultation
                      </p>
                      <p className="text-[13.9px] max-md:text-[13.96px] font-[500] text-[#1A1A1AE5] lg:w-[80%]">
                        One Free Detailed video Kundli Consultation with our top expert and a remedy follow up in 3 months.
                      </p>
                    </div>
                  </div>
                  <div className="flex flex-row items-center justify-center gap-[22px]">
                    <img src="/astro-gold/wallet.png" alt="" />
                    <div className="flex flex-col items-start justify-center">
                      <p className="text-[15.9px] max-md:text-[15.98px] font-[700] text-[#1A1A1A]">
                        20% Off
                      </p>
                      <p className="text-[13.9px] max-md:text-[13.96px] font-[500] text-[#5f5f5f] lg:w-[80%]">
                        Extra 20% off on all the Courses and Astrolearn Gemstone Store.
                      </p>
                    </div>
                  </div>{" "}
                  <div className="flex flex-row items-center justify-center gap-[22px]">
                    <img src="/astro-gold/opened-book.png" alt="" />
                    <div className="flex flex-col items-start justify-center">
                      <p className="text-[15.9px] max-md:text-[15.98px] font-[700] text-[#1A1A1A]">
                        Access to Astrolearn Mall
                      </p>
                      <p className="text-[13.9px] max-md:text-[13.96px] font-[500] text-[#5f5f5f] lg:w-[80%]">
                        Premium access and authenticated gemstones and reduraksh at very low prices.{" "}
                      </p>
                    </div>
                  </div>{" "}
                  <div className="flex flex-row items-center justify-center gap-[22px]">
                    <img src="/astro-gold/folded-hands.png" alt="" />
                    <div className="flex flex-col items-start justify-center">
                      <p className="text-[15.9px] max-md:text-[15.98px] font-[700] text-[#1A1A1A]">
                        E-Pooja
                      </p>
                      <p className="text-[13.9px] max-md:text-[13.96px] font-[500] text-[#5f5f5f] lg:w-[80%] xl:hidden">
                        E-pooja and vidhi-vidhan of every hindu festival will be provided. <br></br>{" "}
                        Healing and meditation session will be conducted<br></br>
                        every morning.{" "}
                      </p>
                      <p className="text-[13.9px] max-md:text-[13.96px] font-[500] text-[#5f5f5f] lg:w-[80%] max-xl:hidden">
                        E-Puja at a mandir of your choice, Vidhi-Vidhan,
                        Meditation/ Self Healing Sessions (morning and evening){" "}
                      </p>
                    </div>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
